export default function (e) {
	
	const text = window.location.href;
	const originalStart = new Date();
	const lag = 1000;

	const deeplinkUrl = `twitter://post?message=${encodeURIComponent(text)}`;
	window.location.href = deeplinkUrl;

	setTimeout(() => {
		const timeSpentWaiting = (new Date() - originalStart);
		if (timeSpentWaiting > (2.0 * lag)) {
			// We can assume they have the app, so do nothing.
		} else {
			// That was too fast so we can assume they don't have the app.
			const intentUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;
			window.open(intentUrl, "_blank");
		}
	}, lag);
	return false;
}
